import { makeObservable, observable, runInAction, action,computed,toJS} from 'mobx';
import { ExpenseService } from '../../services/expenseServices';
import i18n from 'i18next';
import { toast } from "react-toastify";
import { lpad } from "../../../utils";
import { UtilsServices } from '../../services/utilsServices';
import moment from 'moment';
export default class ExpensesWithCostsFormStore {
    getConvertedAmount = (expense) => expense.amount && expense.currencyId && expense.exchangeRate ? this.roundAwayFromZero(expense.exchangeRate * expense.amount, 2) : "";
    sumArray = (a) => a?.reduce((total, quantity) => total + (Number(quantity) || 0), 0);
    updateVat = (expense, vats) => {
        if (expense.expenseVatRateId) {
            var vat = vats?.find(x => x.id == expense.expenseVatRateId);


            var convertedAmount = parseFloat(this.getConvertedAmount(expense)).toFixed(2);
            var vatAmount = ((convertedAmount / (1 + (vat.tax / 100))) - convertedAmount) * -1;
            //var amountExVat = (convertedAmount * vat.tax) / 100;            

            expense.localCurrencyVATAmount = ((expense.amount / (1 + (vat.tax / 100))) - expense.amount) * -1;

            if (!!expense.diff) {
                expense.vatAmount -= expense.diff;
                expense.localCurrencyVATAmount -= expense.diff;
            }

            expense.vatAmount = expense.localCurrencyVATAmount.toFixed(2) * expense.exchangeRate;

        }
        else {
            expense.vatAmount = null;
            expense.localCurrencyVATAmount = null;
        }
    }
    updateExchangeRateManually = () => {

    }
    isLocalCurrency = (currencies, id) => currencies?.find(x => x.id == id)?.code?.toUpperCase() === "CHF"
    showWarningAllowance = (expense) => this.getConvertedAmount(expense)<50
    isSelectedCurrencyIsTheSameAsTheExpense = (currencies, expenseCurrencyId, currentCurrencyCode) => { return currencies?.find(x => x.id == expenseCurrencyId)?.code?.toUpperCase() == currentCurrencyCode; }

    rootStore;

    costsExpense = {
        items: []
    };

    criteria = {
    };

    isLoading = true;
    
    constructor(rootStore) {
        this.rootStore = rootStore;

        makeObservable(this, {
            isLoading: observable,
            costsExpense: observable,
            getCostsExpense: action,
            getTotal: computed,
            getTotalVAT: computed,
            add: action,
            remove: action,
            save: action,
            setAttachment: action, 
            canEdit: computed,
            updateExchangeRate: action,
            isSelectedCurrencyIsTheSameAsTheExpense: action,
            updateExchangeRateManually : action
        });
    }
    setAttachment = (expense,attachment) => {
        runInAction(() => {            
            expense.attachmentId = attachment?.id ?? null;
            expense.attachment = attachment;            
        })
    }
    save = async (event) => {
        try {
            runInAction(() => {
                this.isLoading = true;
            });

            event.preventDefault();
            const form = event.currentTarget;

            if (form.checkValidity() === false) {
                event.preventDefault();
                event.stopPropagation();
            }
            else {

                for (var i = 0; i < this.costsExpense.items.length; i++) {
                    if (!this.costsExpense.items[i].expenseVatRateId)
                        this.costsExpense.items[i].expenseVatRateId = null;
                }
                
                var data = await ExpenseService.saveExpenseWithCosts(this.costsExpense);
                runInAction(() => {
                    toast.success(i18n.t('internalExpensesWithPackageSavedSuccessfully'));
                    this.getCostsExpense(this.criteria.year, this.criteria.month, this.criteria.currencyId,this.criteria.devId);
                });
            }
        } catch {
            runInAction(() => {
            });
        } finally {
            runInAction(() => {
                this.isLoading = false;
            });
        }
    }

    add = () => {
        runInAction(() => {            
            this.costsExpense.items.push({ date: `${this.criteria.year}-${lpad(this.criteria.month, 2)}-01`, amount: null, vatAmount: null, localCurrencyVATAmount: null });
        });
    }

    remove = (i) => {
        runInAction(() => {
            this.costsExpense.items.splice(i, 1);
        });
    }

    getCostsExpense = async (year,month,currencyId,devId) => {        
        try {

            runInAction(() => {
                this.isLoading = true;                
                this.criteria.month = month;
                this.criteria.year = year;
                this.criteria.currencyId = currencyId;
                this.criteria.devId = devId;
                   
            });

            var data = await ExpenseService.getCostsExpense(this.criteria);

            runInAction(() => {
                this.costsExpense = data;
                this.costsExpense.devId = devId;
            });
        } catch {
            runInAction(() => {
                this.costsExpense = {
                    items: []
                };
            });
        } finally {
            runInAction(() => {                
                this.isLoading = false;
            });
        }
    }

    updateExchangeRate = async (expense, exchangeRates) => {

        var d = moment(expense.date);
        var month = d.month() + 1;
        var year = d.year();

        if (!expense.currencyId) {
            expense.exchangeRate = null;
            return;
        }

        runInAction(async () => {
            expense.rateLoading = true;
        });
        
        await UtilsServices.getExchangeRate(year, month, expense.currencyId, this.costsExpense?.currency?.shortName).then(rates => {

            var rate = rates.find(x =>
                x.to.code.toUpperCase() == this.costsExpense?.currency?.shortName?.toUpperCase()
                && x.from.id == expense.currencyId && x.month == month && x.year == year)?.rate ?? '';

            runInAction(async () => {
                expense.exchangeRate = rate;
            });

        });        

        runInAction(async () => {
            expense.rateLoading = false;
        });

    }
    
    get getTotal() {
        return this.sumArray(this.costsExpense.items.map((item) => this.getConvertedAmount(item)))?.toFixed(2);
    }

    get getTotalVAT() {
        return this.sumArray(this.costsExpense.items.map((item) => item.vatAmount?.toFixed(2)))?.toFixed(2)
    }


    get canEdit() {
        return this.costsExpense?.canEdit//status === 0 || this.costsExpense?.status === 3
    }

    roundAwayFromZero = (number, decimalPlaces) => {
        if (decimalPlaces === undefined) {
            const sign = Math.sign(number);
            const absNum = Math.abs(number);
            const roundedAbs = Math.round(absNum);

            if (absNum - Math.floor(absNum) === 0.5) {
                return sign * (Math.floor(absNum) + 1);
            } else {
                return sign * roundedAbs;
            }

        } else {
            const factor = Math.pow(10, decimalPlaces);
            const scaledNumber = number * factor;
            const sign = Math.sign(scaledNumber);
            const absScaledNum = Math.abs(scaledNumber);
            const roundedAbsScaled = Math.round(absScaledNum);

            if (absScaledNum - Math.floor(absScaledNum) === 0.5) {
                return (sign * (Math.floor(absScaledNum) + 1)) / factor;
            } else {
                return (sign * roundedAbsScaled) / factor;
            }
        }
    }
}